import React, { useEffect, useState } from 'react';
import axios from 'axios';

import PageHeading from '../../components/headings/pageHeading';
import Modal from '../../components/modal/modal';
import AlertWithClose from '../../components/alert/alertWithClose';
    


const CreateBrand = () => {

    const [formData, setForm] = useState(null);
    const [brands, setBrands] =  useState([]);
    const [deleteData, setDeleteData] =  useState(null);
    const [alertData, setAlertData] = useState(null)

    // const auth = useContext(AuthContext)
    // console.log(auth)

    const onImageChange = (event) => {
        if (event.target.files && event.target.files[0]) {
            setForm(prev => ({
                ...prev, 
            imageUrl: URL.createObjectURL(event.target.files[0])
          }));
        }
       }

    const formChanges = (e) => {
        const {name, value, files} = e.target;

        setForm(prev => ({
            ...prev,
            [name]: value
        }))
        if(name==='image'){
            setForm(prev => ({
                ...prev,
                [name]: files[0]
            }))
            onImageChange(e)
        }
        console.log(e, name, value)
    }

    
    const clearForm = () =>{
        document.getElementById('BrandCreateForm').reset();
        setForm(null);
    }


    const loadBrands = async()=>{
        try {
            const url = `${process.env.REACT_APP_BASE_URL}/admin-users/brand`;
            const token = localStorage.getItem('authKey');
            const response = await axios.get(url, { headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` } });

            setBrands(response.data.brands )
            console.log(response);


        }
        catch (e) {
            console.log(e);
        }
    }

    useEffect(async()=>{
        await loadBrands()
    },[])


    const submitHandler = async (e)=>{
        // onClick={submitHandler}

        try{
        e.preventDefault();
        console.log(formData, e)

        const url = `${process.env.REACT_APP_BASE_URL}/admin-users/brand`;
        const reqFormData = new FormData();
        
        reqFormData.append('name', formData.name);
        reqFormData.append('upload', formData.image);

        const token = localStorage.getItem('authKey');

        console.log(reqFormData)

        const response = await axios.post(url,reqFormData, {headers: {
            'content-type': 'multipart/form-data',
            Authorization: `Bearer ${token}`
        }
        
    } )
    

    if(response.status===200){
        setAlertData({message: 'Brand Added', type:'good'})
        clearForm()
        loadBrands()

    }
        }catch(error){
            if(error.name ==='AxiosError'){
                
                setAlertData({message: error.response.data.error, type:'bad'})
            }
            else
            setAlertData({message:'Unable to delete brand', type:'bad'})
        }

    }

    const clearAlert= ()=>{
        setAlertData(null);
    }

    /* eslint-disable no-underscore-dangle */
    const loadDeleteData = (index)=>{
        setDeleteData(brands[index]);
    }

    const clearDeleteData =  ()=>{
        setDeleteData(null)
    }

    const deleteBrand =async ()=>{

        try{
            const url = `${process.env.REACT_APP_BASE_URL}/admin-users/brand/${deleteData._id}`;
    
            const token = localStorage.getItem('authKey');
    
            const response = await axios.delete(url, {headers: {
                Authorization: `Bearer ${token}`
            }
        } )
    
        if(response.status===200){
            setAlertData({message: 'Brand deleted', type:'good'});

            loadBrands()
        }
            }catch(error){
                if(error.name ==='AxiosError'){
                    
                    setAlertData({message: error.response.data.error, type:'bad'})
                }
                else
                setAlertData({message:'Unable to delete brand', type:'bad'})
            }
        
            clearDeleteData();

    }

    return ( 
        <div className="create-brand w-full">
            <PageHeading heading='Brands' />
            <form onSubmit={submitHandler} id="BrandCreateForm">
            <div className="flex flex-row">
                    <div className="px-4 py-3"><input type="text" name='name' className="form-input rounded outline-slate-400 px-4 py-3 outline-2 w-96 bg-slate-300" placeholder="Enter Brand name" onChange={formChanges} /></div>
                    <div className="px-4 py-3"><input type="file" name='image' className="block form-control w-full h-full w-96 text-base font-normal bg-slate-300 text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none" placeholder="Enter Brand name" accept="image/*" onChange={formChanges} /></div>
                    <div className="px-4 py-3"><button type="submit" className="bg-yellow-400 shadow-lg hover:shadow focus:shadow-sm shadow-black-400/50  px-3 p-2 rounded w-96" >Add Brand</button> </div>
                </div>
                {formData && formData.imageUrl && <img className="h-24 px-5" src={formData.imageUrl} alt='Brand name' />}
            </form>

            <table className="text-sm text-left text-slate-500 mx-5 ">
                        <thead className="text-xs text-gray-700 uppercase bg-gray-200 ">
                            <tr>
                            <th scope="col" className="px-6 py-3">
                                    ID
                                </th>
                                <th scope="col" className="px-6 py-3">
                                    Name
                                </th>
                                <th scope="col" className="px-6 py-3">
                                    Created At
                                </th>
                                <th scope="col" className="px-6 py-3">
                                    Image
                                </th>
                                <th scope="col" className="px-6 py-3">
                                    Actions
                                </th>
                            </tr>
                        </thead>
                        <tbody>


                            {brands && brands.map((referal, index) =>
                                <tr className={`bg-white border-b hover:bg-slate-200 ${index%2===0?'': 'bg-slate-100'}`}>
                                    <th scope="row" className="px-6 py-4 font-medium text-gray-900 ">
                                        {referal._id}
                                    </th>
                                    <th scope="row" className="px-6 py-4 font-medium text-gray-900 ">
                                        {referal.name}
                                    </th>
                                    <td className="px-6 py-4">
                                        {referal.created_at}
                                    </td>
                                    <td className="px-6 py-4 h-10 ">
                                        {referal.image_url? <img src={referal.image_url} alt={referal.name} className='h-10'/> : <span>No Image</span>}
                                    </td>
                                    <td className="px-6 py-4 h-10 ">
                                    <button type="submit" className="bg-red-600 shadow-lg hover:shadow focus:shadow-sm shadow-black-400/20 h-full px-3 p-2 rounded w-24 text-white" onClick={()=>loadDeleteData(index)} >Delete</button>
                                    </td>
                                </tr>
                            )}

                        </tbody>
                    </table>

                    {deleteData && <Modal description={`Do you want to delete ${deleteData.name} ?`} onSuccess={deleteBrand} onCancel={clearDeleteData} /> }
                    { alertData && <AlertWithClose clearAlert={clearAlert} message={alertData.message} time={4} type={alertData.type} />}
        </div>
     );
}
 
export default CreateBrand;